import store from '../store/index.js'
export default {
	filters:{
		imgurl(imgsrc){
			if(imgsrc) {
				if(imgsrc.substring(0,4)=='http'){
					return imgsrc;
				}
				return store.state.imgSrc + imgsrc;
			}else {
				return
			}
			
		}
	}
};


// WEBPACK FOOTER //
// ./src/util/mixin/commin.js